import Vue from 'vue'
import vSelect from 'vue-select'

// Kept disabled: enabling it swaps the X/chevron icons of every v-select in the app
// vSelect.props.components.default = () => ({
//   Deselect: {
//     render: h => h('feather-icon', { props: { size: '14', icon: 'XIcon' } }),
//   },
//   OpenIndicator: {
//     render: h => h('feather-icon', { props: { size: '15', icon: 'ChevronDownIcon' }, class: 'open-indicator' }),
//   },
// })

// vue-select 3.x hardcodes English titles/aria-labels; translate them via i18n
vSelect.mixins = [
  ...(vSelect.mixins || []),
  {
    watch: {
      '$i18n.locale': 'translateA11yTexts',
    },
    mounted() {
      this.translateA11yTexts()
    },
    updated() {
      this.translateA11yTexts()
    },
    methods: {
      translateA11yTexts() {
        if (!this.$t) return
        const setText = (el, text) => {
          if (!el) return
          if (el.getAttribute('title') !== text) el.setAttribute('title', text)
          if (el.getAttribute('aria-label') !== text) el.setAttribute('aria-label', text)
        }
        setText(this.$refs.clearButton, this.$t('GENERAL.VSelectClearSelected'))
        if (this.$refs.toggle) this.$refs.toggle.setAttribute('aria-label', this.$t('GENERAL.VSelectSearchOption'))
        const buttons = this.$refs.deselectButtons || []
        const selected = Array.isArray(this.selectedValue) ? this.selectedValue : []
        buttons.forEach((btn, i) => {
          const label = selected[i] !== undefined ? this.getOptionLabel(selected[i]) : ''
          setText(btn, `${this.$t('GENERAL.VSelectRemoveOption')} ${label}`.trim())
        })
      },
    },
  },
]

Vue.component(vSelect)
